import { Injectable, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { WebrtcMeshService } from './webrtc-mesh.service';
// If you have a WebSocket service, import it here as well

declare var ForegroundService: any;

@Injectable({ providedIn: 'root' })
export class AndroidForegroundService {
  private isRunning = false;

  constructor(
    private platform: Platform,
    private ngZone: NgZone,
    private webrtcMeshService: WebrtcMeshService,
    // private websocketService: YourWebSocketService
  ) { }

  /**
   * Start the Android foreground service and (re)connect mesh/network.
   */
  public async startForegroundSession(sessionType: 'audio' | 'counting' | 'both' = 'both') {
    if (!this.platform.is('android')) return;
    if (this.isRunning) return;

    this.ngZone.runOutsideAngular(() => {
      if (window['ForegroundService']) {
        ForegroundService.start({
          id: 1,
          title: 'Aforo Mesh',
          text: sessionType === 'audio'
            ? 'Audio streaming is running in the background'
            : sessionType === 'counting'
              ? 'Counting session is running in the background'
              : 'Audio and counting are running in the background',
          icon: 'ic_launcher',
          importance: 'max'
        });
        this.isRunning = true;
        console.log('[AndroidForegroundService] Foreground service started');
      }
    });

    // Optionally, (re)connect your mesh or WebSocket here
    // await this.websocketService.connect();
    // await this.webrtcMeshService.initMesh(currentEventId, isCreator);
  }

  /**
   * Stop the Android foreground service and disconnect mesh/network if needed.
   */
  public stopForegroundSession() {
    if (!this.platform.is('android')) return;
    if (!this.isRunning) return;

    this.ngZone.runOutsideAngular(() => {
      if (window['ForegroundService']) {
        ForegroundService.stop();
        this.isRunning = false;
        console.log('[AndroidForegroundService] Foreground service stopped');
      }
    });

    // Optionally, disconnect your mesh or WebSocket here
    // this.websocketService.disconnect();
    // this.webrtcMeshService.cleanupMesh();
  }

  /**
   * Utility: Check if the foreground service is running.
   */
  public isForegroundServiceRunning(): boolean {
    return this.isRunning;
  }
}